import produce from 'immer';
export function reducer(state, action) {
    switch (action.type) {
        case 'LOGIN':
            return produce(state, draft => {
                draft.loggedIn = true;
                draft.list = action.payload;
            });
        case 'LOGOUT': {
            return produce(state, draft => {
                draft.loggedIn = false;
                draft.list = {};
            });
        }
        case 'UPDATE': {
            const { articleNumber, variantArticleNumber, options, variantToReplace } = action.payload;
            return replaceItemInList(state, articleNumber, {
                variantArticleNumber,
                variantToReplace,
                options
            });
        }
        case 'ADD': {
            const { variantArticleNumber, articleNumber, options } = action.payload;
            if (variantArticleNumber) {
                return addVariantToList(state, articleNumber, {
                    variantArticleNumber,
                    options
                });
            }
            else {
                return addBaseProductToList(state, articleNumber, options);
            }
        }
        case 'REMOVE': {
            const { variantArticleNumber, articleNumber } = action.payload;
            const list = removeFromList(state, articleNumber, {
                variantArticleNumber
            });
            return list;
        }
        case 'REPLACE': {
            return produce(state, draft => {
                draft.list = action.payload;
            });
        }
        default:
            throw new Error(`Unsupported action ${action} for product list reducer`);
    }
}
export function init(initialState) {
    if (typeof window === 'undefined')
        return initialState;
    const updatedState = {
        list: JSON.parse(window.localStorage.getItem('productList')) ||
            initialState.list ||
            null,
        loggedIn: initialState.loggedIn
    };
    return updatedState;
}
export function addVariantToList(state, articleNumber, { variantArticleNumber, options }) {
    // If the article number exists, update it
    // Otherwise create a new entry
    return produce(state, draft => {
        var _a, _b;
        draft.list[articleNumber] = {
            options: ((_a = draft.list[articleNumber]) === null || _a === void 0 ? void 0 : _a.options) || null,
            variants: produce(((_b = draft.list[articleNumber]) === null || _b === void 0 ? void 0 : _b.variants) || {}, draft => {
                draft[variantArticleNumber] = {
                    options,
                    parentArticleNumber: articleNumber
                };
            })
        };
    });
}
export function addBaseProductToList(state, articleNumber, options) {
    return produce(state, draft => {
        var _a;
        draft.list[articleNumber] = {
            variants: ((_a = draft.list[articleNumber]) === null || _a === void 0 ? void 0 : _a.variants) || null,
            options
        };
    });
}
export function removeFromList(state, articleNumber, { variantArticleNumber }) {
    if (variantArticleNumber) {
        return produce(state, draft => {
            delete draft.list[articleNumber].variants[variantArticleNumber];
            if (Object.keys(draft.list[articleNumber].variants).length === 0 &&
                draft.list[articleNumber].options === null) {
                delete draft.list[articleNumber];
            }
        });
    }
    else {
        return produce(state, draft => {
            if (draft.list[articleNumber].variants) {
                draft.list[articleNumber].options = null;
            }
            else {
                delete draft.list[articleNumber];
            }
        });
    }
}
export function replaceItemInList(state, articleNumber, { variantToReplace, variantArticleNumber, options }) {
    if (variantToReplace) {
        return produce(state, draft => {
            // Replacing is a delete + an add
            const variants = draft.list[articleNumber].variants;
            delete variants[variantToReplace];
            draft.list[articleNumber].variants = Object.assign(Object.assign({}, variants), { [variantArticleNumber]: {
                    options,
                    parentArticleNumber: articleNumber
                } });
        });
    }
    else {
        return produce(state, draft => {
            var _a;
            draft.list[articleNumber] = {
                options: null,
                variants: Object.assign(Object.assign({}, (_a = draft.list[articleNumber]) === null || _a === void 0 ? void 0 : _a.variants), { [variantArticleNumber]: {
                        options,
                        parentArticleNumber: articleNumber
                    } })
            };
        });
    }
}
//# sourceMappingURL=product-list-reducer.js.map